// src/pages/myPlan/components/SwitchToBoxPlanModal/SwitchToBoxPlanModal.tsx
import { CuiSpinner } from 'front-lib'
import { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useChangeToBoxPlan } from '../../../../api/BoxOrderinngModel/changeToBoxPlan'
import { ResponsiveModalOrBottomSheet } from '../../../../components/ResponsiveModalOrBottomSheet/ResponsiveModalOrBottomSheet'
import { getSubscriptionData } from '../../../../redux-api-bridge'
import { getUserId } from '../../../../redux-api-bridge/account/selectors'
import { toaster } from '../../../../utils/toaster'

// Import the same steps components from the original modal
import { BoxSelectionStep } from '../../../../modules/Modals/components/BoxOrderPlanModal/steps/BoxSelectionStep'
import { SuccessStep } from '../../../../modules/Modals/components/BoxOrderPlanModal/steps/SuccessStep'

// Reuse the SCSS if needed
import 'src/modules/Modals/components/BoxOrderPlanModal/BoxOrderPlanModal.scss'
import { BoxSizePlanOfferModalTemplate } from '../../hooks/useGetBoxPlanOffer'

type SwitchToBoxPlanModalProps = {
  isOpen: boolean
  onClose: () => void
  data: BoxSizePlanOfferModalTemplate
}

export function SwitchToBoxPlanModal({
  isOpen,
  onClose,
  data
}: SwitchToBoxPlanModalProps) {
  const userId = useSelector(getUserId)
  const dispatch = useDispatch()

  const [step, setStep] = useState<'box-size-selection' | 'success'>(
    'box-size-selection'
  )

  const { changeToBoxPlan, loading } = useChangeToBoxPlan({
    onCompleted,
    onError
  })

  function handleChangePlan(planBoxId: number) {
    // Track differently from the system modal if needed
    // trackUserInitiatedBoxPlanSwitch()
    changeToBoxPlan({ userId, planBoxId })
  }

  function onCompleted(response) {
    if (response.changeToBoxPlan?.success) {
      setStep('success')
    } else {
      onError(response)
    }
  }

  function onSuccess() {
    dispatch(getSubscriptionData)
    window.location.href = '/nextMenu'
  }

  function onError(response) {
    toaster.error(response.changeToBoxPlan?.error)
  }

  const orderedBoxes = useMemo(() => {
    return [...(data.boxes || [])].sort((a, b) => a.minPrice - b.minPrice)
  }, [data.boxes])

  if (!data.boxes || data.boxes.length === 0) {
    return null
  }

  return (
    <ResponsiveModalOrBottomSheet
      onClose={onClose}
      isOpen={isOpen}
      className="box-order-plan-modal"
      data-testid="switch-to-box-plan-modal">
      {loading && (
        <div className="spinner-overlay">
          <CuiSpinner width="24px" />
        </div>
      )}
      <div className="image" />
      {step === 'box-size-selection' && (
        <BoxSelectionStep
          onConfirm={handleChangePlan}
          onBack={() => onClose()}
          boxes={orderedBoxes}
          userPlanMatchBoxId={data.userPlanMatchBoxId}
          mostPopularBoxId={data.mostPopularBoxId}
        />
      )}
      {step === 'success' && <SuccessStep onSuccess={onSuccess} />}
    </ResponsiveModalOrBottomSheet>
  )
}
